import React from "react";
// import "./NoGames.scss";
import { useNavigate } from "react-router-dom";

const NoPayment = () => {
  const navigate = useNavigate();
  return (
    <div className="no-games-container">
      <h1 className="heading">No payments found</h1>
      <p className="subtext" style={{ marginTop: "0.3rem" }}>
        Which also means... no games played.
      </p>
      <p className="subtext">Time to fix that</p>
      <button
        className="book-game-btn"
        onClick={() => {
          navigate("/dashboard/reserve");
        }}
      >
        Book your Game
      </button>
    </div>
  );
};

export default NoPayment;
